import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { noop, Observable, Observer, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Customers } from 'src/app/models/customers';
import { ResponseDTO } from 'src/app/models/response-dto';
import { CustomerFilterOption } from 'src/app/searchFilters/CustomerFilterOption';
import { CustomerService } from 'src/app/services/customer-service.service';

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.css']
})
export class CustomerSearchComponent implements OnInit, OnChanges {

  @Output() customerChange = new EventEmitter<any>();
  @Input() customer: Customers;
  @Input() isRequired: boolean = false;

  @Input() isShowUnknown: boolean = true;

  suggestions$: Observable<any[]>;
  typeaheadLoading: boolean = false;
  customerCode: string = '';
  isLoadingCustomer: Boolean;
  customerFilter: CustomerFilterOption = new CustomerFilterOption();

  constructor(private customerApi: CustomerService) { }

  ngOnChanges(changes: any): void {
    this.customer = changes.customer.currentValue;
    if (this.customer)
      this.customerCode = this.customer.customerCode;
    else
      this.customerCode = "";
  }

  ngOnInit(): void {
    if (this.customer) {
      this.customerCode = this.customer.customerCode;
    }
    this.suggestions$ = new Observable((observer: Observer<string>) => {

      observer.next(this.customerCode);
    }).pipe(
      switchMap((query: string) => {
        if (query) {
          this.isLoadingCustomer = true;
          query = query.replace('^\S+(?: \S+)*$', '').trim();
          this.customerFilter.searchKey = query;
          this.customerFilter.IncludeUnknownCustomer = true;
          return query.length < 2 ? [] : this.customerApi.customersGlobalSearch(1, 10, 'asc', 'customerCode', this.customerFilter)
            .pipe(
              map((data: ResponseDTO) => {
                if (data && data["result"]) {
                  this.isLoadingCustomer = false;
                  let customers = data["result"]["values"];
                  if (!this.isShowUnknown)
                    customers = customers.filter(x => { return x.customerId !== 0 });
                  return customers;
                }
                else {
                  this.isLoadingCustomer = false;
                  return [];
                }
              }),
              tap(() => noop, err => {
                this.isLoadingCustomer = false;
                alert(err && err.message || 'customer not found.');

              })
            );
        }
        else {
          this.isLoadingCustomer = false;
          return of([]);
        }
      })
    );
  }

  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  typeaheadCustomerOnSelect(e: TypeaheadMatch): void {
    if (this.customer)
      this.customerCode = this.customer.customerCode;
    this.customerChange.emit(e.item);
  }

  keydown(event) {    
    var input = event.target;
    var val = input.value;
    var end = input.selectionEnd;
    if (event.keyCode == 32 && (val[end - 1] == " " || val[end] == " ")) {
      event.preventDefault();
      return false;
    }
  }

}
